import { render } from "./passwordReset.vue?vue&type=template&id=55591f94&scoped=true"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"

import "./passwordReset.vue?vue&type=style&index=0&id=55591f94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55591f94"]])

export default __exports__